/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

/** Source score tracking for multi-source reputation aggregation */
export type SourceScore = {
  /** Source identifier (e.g., "payai", "github", "custom-webhook") */
  sourceName: string;
  /** Reputation score from this source (0-1000) */
  score: number;
  /** Weight in basis points (0-10000, where 10000 = 100%) */
  weight: number;
  /** Number of data points contributing to this score */
  dataPoints: number;
  /** Source reliability score in basis points (0-10000) */
  reliability: number;
  /** Last time this source was updated */
  lastUpdated: bigint;
};

export type SourceScoreArgs = {
  /** Source identifier (e.g., "payai", "github", "custom-webhook") */
  sourceName: string;
  /** Reputation score from this source (0-1000) */
  score: number;
  /** Weight in basis points (0-10000, where 10000 = 100%) */
  weight: number;
  /** Number of data points contributing to this score */
  dataPoints: number;
  /** Source reliability score in basis points (0-10000) */
  reliability: number;
  /** Last time this source was updated */
  lastUpdated: number | bigint;
};

export function getSourceScoreEncoder(): Encoder<SourceScoreArgs> {
  return getStructEncoder([
    ["sourceName", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["score", getU16Encoder()],
    ["weight", getU16Encoder()],
    ["dataPoints", getU32Encoder()],
    ["reliability", getU16Encoder()],
    ["lastUpdated", getI64Encoder()],
  ]);
}

export function getSourceScoreDecoder(): Decoder<SourceScore> {
  return getStructDecoder([
    ["sourceName", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["score", getU16Decoder()],
    ["weight", getU16Decoder()],
    ["dataPoints", getU32Decoder()],
    ["reliability", getU16Decoder()],
    ["lastUpdated", getI64Decoder()],
  ]);
}

export function getSourceScoreCodec(): Codec<SourceScoreArgs, SourceScore> {
  return combineCodec(getSourceScoreEncoder(), getSourceScoreDecoder());
}
